import {
  TextField,
  TextInput,
  required,
  ReferenceArrayInput,
  ReferenceArrayField,
  AutocompleteArrayInput,
  useResourceDefinition,
  SingleFieldList,
  WithRecord,
} from "react-admin";
import { RecordSummary, MyShow } from "../../ra-lb-tools/components/MyShow";
import { Chip } from "@mui/material";
import {
  MyReferenceField,
  MyReferenceInput,
} from "../../ra-lb-tools/components/myReference";
import { MyList } from "../../ra-lb-tools/components/myList";
import { LabeledColumn } from "../../ra-lb-tools/components/labeledColumn";
import { MyCreate as Create } from "../../ra-lb-tools/components/myMutator";
import { PlanSubscriptionList } from "./plan_subsciptions";
import { useParams } from "react-router-dom";
import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  MyTabbedShowLayout,
  Tab,
} from "../../ra-lb-tools/components/myTabbedShowLayout";
import AddPriceButton from "./addPriceButton";
import { MyDateField } from "../../ra-lb-tools/components/myDateField";
import { ReferenceInputString } from "../../ra-lb-tools/components/referenceInputString";
export const PlanIcon = AddShoppingCartOutlined;

const PricesList = () => {
  const { recordRepresentation } = useResourceDefinition({
    resource: "prices",
  });

  const renderChip = (record) => (
    <Chip label={recordRepresentation(record)} sx={{ marginTop: "10px" }} />
  );

  return (
    <ReferenceArrayField source="prices" reference="prices">
      <SingleFieldList linkType={false}>
        <WithRecord render={renderChip} />
      </SingleFieldList>
    </ReferenceArrayField>
  );
};

const PlanTypeInput = (props) => (
  <ReferenceInputString reference="plan-types" source="type" {...props} />
);

export const PlanList = (props) => (
  <MyList {...props} resource="plans">
    <TextField source="id" />
    <TextField source="name" />
    <TextField source="description" />
    <TextField source="type" />
    <PricesList label={"Prices"} />
    <MyDateField source="createdAt" showTime />
    <MyDateField source="updatedAt" showTime />
  </MyList>
);

export const PlanShow = () => {
  const id = parseInt(useParams()["id"]);

  return (
    <MyShow>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <TextField source="name" />
              <TextField source="description" />
              <TextField source="type" />
              <PricesList label="Prices" />
              <AddPriceButton can={{ resource: "plan", action: "add_price" }} />
            </LabeledColumn>
            <LabeledColumn>
              <MyDateField source="createdAt" showTime />
              <MyDateField source="updatedAt" showTime />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
        <Tab
          label="Subscriptions"
          path="Subscriptions"
          can={{ action: "list", resource: "plan-subscriptions" }}
        >
          <PlanSubscriptionList filter={{ planId: id }} />
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};

export const PlanCreate = (props) => {
  return (
    <Create {...props}>
      <TextInput source="name" validate={required()} />
      <TextInput source="description" />
      <PlanTypeInput source="type" />
      <ReferenceArrayInput source="prices" reference="prices">
        <AutocompleteArrayInput
          filterToQuery={(searchText) => ({ product_name: `${searchText}` })}
        />
      </ReferenceArrayInput>
    </Create>
  );
};

export const PlanInput = (props) => {
  return <MyReferenceInput source="planId" reference="plans" {...props} />;
};

export const PlanField = (props) => {
  return <MyReferenceField source="planId" reference="plans" {...props} />;
};
